/* unplugin-vue-components disabled */import script from "./family-project-dialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./family-project-dialog.vue?vue&type=script&setup=true&lang=ts"

import "./family-project-dialog.vue?vue&type=style&index=0&id=49d37926&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-49d37926"]])

export default __exports__